import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from "prop-types";
import GridListTile from "@material-ui/core/GridListTile";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import jobsListStyle from "../../assets/jss/jobsListStyle";
import Pagination from "../../components/Pagination";
import axios from "axios";
import Grid from "@material-ui/core/Grid";
import { END_POINT_JOBS } from "../../api/EndPoint";
import sha256 from "crypto-js/sha256";
import { Button } from "@material-ui/core";
import '../../assets/css/jobsListStyle.css'
import * as Sentry from '@sentry/browser'
import Loader from '../../components/Loader';

Sentry.init({
  dsn: "https://8b7fd3762e754bab8c1c1e62dd17f0db@sentry.io/1388765"
});


const today = new Date().toGMTString();

class JobsList extends Component {

  state = {
    loading: true,
    allJobs: [],
    currentPage: 1,
    keywords: "",
    category: "",
    entity: "",
    refresh: false,
    totalJobs: 0,
  };

  componentDidMount = async () => {
    axios({
      method: "get",
      headers: {
        Authorization:
          "Bearer " +
          sha256(
            Math.random()
              .toString(36)
              .substring(7)
          ),
        'pragma': 'no-cache',
        'cache-control': 'no-cache',
      },
      url: END_POINT_JOBS,//+ "?sort=-_created",
      params: { 
        sort: "-_created",
        where: '{"close_date": {"$gt": "'+ today + '"}}'
      }
    }).then(res => {
      const allJobs = res.data._items;
      this.setState({ allJobs });
      this.setState({ totalJobs: res.data._meta.total });
      this.setState({ loading: false });
    });


  };

  componentDidUpdate = async () => {
    if (
      this.props.keywords !== this.state.keywords ||
      this.props.category !== this.state.category ||
      this.props.entity !== this.state.entity
    ) {
      this.setState({
        keywords: this.props.keywords,
        category: this.props.category,
        entity: this.props.entity
      });
      axios({
        method: "get",
        headers: {
          Authorization:
            "Bearer " +
            sha256(
              Math.random()
                .toString(36)
                .substring(7)
            ),
          'pragma': 'no-cache',
          'cache-control': 'no-cache',
        },
        url:
          END_POINT_JOBS +
          "?sort=-_created" +
          '&where={' +
          '"close_date": {"$gt": "'+ today + '"},' +
          '"title": {"$regex": ".*' + this.props.keywords + '.*", "$options": "-i" },' +
          '"category": {"$regex": ".*' + this.props.category + '.*"}' +
          ', "entity": {"$regex": ".*' + this.props.entity + '.*"}' +
          '}' +
          '&page=' + 1
      }).then(res => {
        const allJobs = res.data._items;
        this.setState({ allJobs });
        this.setState({ totalJobs: res.data._meta.total });
        this.setState({ keywords: this.props.keywords });
        this.setState({ category: this.props.category });
        this.setState({ entity: this.props.entity });
        this.setState({ currentPage: 1 });
        this.setState({ refresh: true });
        this.setState({ refresh: false });
      });
    }
  };

  componentDidCatch(error, errorInfo) {
    Sentry.withScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });
  }

  changePage = async (data) => {
    const { currentPage } = data;
    axios({
      method: "get",
      headers: {
        Authorization:
          "Bearer " +
          sha256(
            Math.random()
              .toString(36)
              .substring(7)
          ),
        'pragma': 'no-cache',
        'cache-control': 'no-cache',
      },
      url:
        END_POINT_JOBS +
        "?sort=-_created" +
        '&where={' +
        '"confidential": false,'+
        '"close_date": {"$gt": "'+ today + '"},' +
        '"title": {"$regex": ".*' + this.props.keywords + '.*", "$options": "-i" },' +
        '"category": {"$regex": ".*' + this.props.category + '.*"}' +
        ', "entity": {"$regex": ".*' + this.props.entity + '.*"}' +
        '}' +
        '&page=' + currentPage
    }).then(res => {
      const allJobs = res.data._items;
      this.setState({ allJobs });
      this.setState({ totalJobs: res.data._meta.total });
      this.setState({ keywords: this.props.keywords });
      this.setState({ category: this.props.category });
      this.setState({ entity: this.props.entity });
      this.setState({ currentPage });
    });
  };

  onPageChanged = data => {
    this.changePage(data)
  };

  render() {
    const { allJobs, loading } = this.state;
    const totalJobs = this.state.totalJobs;
    const { classes, goToDetails } = this.props;


    if (loading === true)
      return (
        <div className={classes.content}>
          <Loader />
        </div>
      )
    else if (totalJobs === 0)
      return (
        <Typography align="center" variant="h5" style={{ marginTop: "85px" }}>
          There are no jobs at this time. Please submit your CV for future opportunities to <br /><a href="mailto: hr@yoma.com.mm">hr@yoma.com.mm</a>
        </Typography>
      );
    return (
      <div className={classes.content}>
        <Grid container spacing={24}>
          {allJobs.length === 0 ? (
            <p style={{ marginTop: "85px" }}>There are no jobs at this time. Please submit your CV for future opportunities to <br /><a href="mailto: hr@yoma.com.mm">hr@yoma.com.mm</a></p>
          ) : (
              allJobs.map((job, key) => (
                <Grid item xs={12} sm={6} key={key}>
                  <GridListTile key={job._id} className={classes.gridListTile}>
                    <Card
                      className={classes.roundedRectangle}
                      onClick={() => goToDetails(job._id)}
                    >
                      <CardContent>
                        <Grid container
                          direction="row">

                          {(job.entity_logo && job.entity_logo!==null) ?
                            <Grid item className="frame">
                                <span className="helper"></span>
                                <img className="logo-img" src={job.entity_logo} width="100" height="100" alt="entity logo"/>
                            </Grid>
                            :
                            <Grid item className="frame">
                                <span className="helper"></span>
                                <img 
                                  className="logo-img" 
                                  src="https://cdn.yomastrategic.net/logos/125x125/yomagroup.png" 
                                  width="100" 
                                  height="100" 
                                  alt="entity logo"/>
                            </Grid>
                          }
                          <Grid item xs={9}>
                            <Typography component="p" className={classes.jobTitle}>
                              {job.title}
                            </Typography>
                            <Typography className={classes.entity}>
                              {job.entity}
                            </Typography>
                            <Typography className={classes.detail} style={{ display: "inline-block", width: "100%" }}>

                              Posted : {formatDate(job._created)}<br />
                              Location : {job.location}<br />
                            </Typography>

                            <Button variant="contained" className="go-to-detail-btn">
                              Apply Now
                            </Button>
                            <Typography style={{ display: "inline-block", width: "100%" }}>
                              {job.category.map((prop, key) => {
                                return (
                                  <Typography
                                    key={key}
                                    className={classes.tags}
                                  >
                                    #&nbsp;{prop}
                                    {key < job.category.length - 1 && " "}
                                    &nbsp;
                                    </Typography>
                                );
                              }
                              )}
                            </Typography>
                            <Typography component="p" className={classes.entity}>
                            </Typography>
                          </Grid>
                        </Grid>

                      </CardContent>
                    </Card>
                  </GridListTile>
                </Grid>
              ))
            )}
        </Grid>
        {this.state.refresh === true ? (
          <div>
            <Pagination
              totalRecords={totalJobs}
              pageLimit={20}
              pageNeighbours={1}
              onPageChanged={this.onPageChanged}
            />
          </div>
        ) : (
            <Pagination
              totalRecords={totalJobs}
              pageLimit={20}
              pageNeighbours={1}
              onPageChanged={this.onPageChanged}
            />
          )}
      </div>
    );
  }
}

function formatDate(string) {
  var options = { year: "numeric", month: "short", day: "numeric" };
  return new Date(string).toLocaleDateString([], options);
}

JobsList.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(jobsListStyle)(JobsList);
